import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-other',
  templateUrl: './alert-other.component.html',
  styleUrls: ['./alert-other.component.css']
})
export class AlertOtherComponent {

}
